
<div class="inner-adjust">
  <div class="pt-3 pb-2 mb-3 border-bottom">
    <h1>Profil utilisateur</h1>
  </div>
  <!-- Show user data when logged in -->
  <div class="row" *ngIf="authService.userData as user">
    <div class="col-md-12">
      <div class="media">
        <div class="media-body">
          <form [formGroup]="dashboardForm" (ngSubmit)="onSubmit()" *ngIf="dashboardForm != null">

            <div class="form-group">
              <label for="nomComplet">Nom : </label>
              <input type="text" formControlName="nomComplet" class="form-control">
            </div>   
            <div class="form-group">
              <label for="adresse">Adresse : </label>
              <input type="text" formControlName="adresse" class="form-control">
            </div>   
            <div class="form-group">
              <label for="telephone">Téléphone : </label>
              <input type="text" formControlName="telephone" class="form-control">
            </div>   
            <div class="form-group">
              <label for="dateDeNaissance">Date de naissance : </label>
              <input type="date" formControlName="dateDeNaissance" class="form-control">
            </div>   
            <h4>Contact d'urgence</h4>
            <ul class="list-unstyled">
              <li>
                <div class="form-group">
                  <label for="contactNomComplet">Nom : </label>
                  <input type="text" formControlName="contactNomComplet" class="form-control">
                </div>   
              </li>
              <li>
                <div class="form-group">
                  <label for="contactRelation">Relation : </label>
                  <input type="text" formControlName="contactRelation" class="form-control">
                </div>   
              </li>
              <li>
                <div class="form-group">
                  <label for="contactNumero">Numéro : </label>
                  <input type="text" formControlName="contactNumero" class="form-control">
                </div>   
              </li>
            </ul>
            
            <div class="form-group">
              <label for="autreInformation">Autres informations : </label>
              <textarea formControlName="autreInformation" class="form-control"></textarea>
            </div>

            <input type="submit" value="Modifier" class="btn btnPrimary mt-3" >
          </form>
        </div>
      </div>
    </div>
  </div>
</div>